import React from 'react';

// Import necessary components
import { Lightbox, PageSidebar, PageTitle } from '../../../components';

// Import icons for visual representation
import { FaCaretRight, FaCheck, FaCircleNotch } from 'react-icons/fa';

// Import useLocation to access route state
import { useLocation } from 'react-router-dom';



const CaseSingle = () => { 

  // Get Case Study details passed via router state
  const location = useLocation();  
  const caseStudy = location.state; 

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={'Case Single'} page={'Case Single'} />

      <section className='case-single page-single'>

        <div className='case-info page-info'>

          {/* Case Study Image Section */}
          <div className='image'>
            <img src={caseStudy.image} alt={caseStudy.title} />
          </div>

          <div className='content'>

            {/* Case Study Title */}
            <h3 className='main-heading'>{caseStudy.title}</h3>

            {/* Case Study Description */}
            {caseStudy.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

            {/* Case Study Image Gallery */}
            <Lightbox images={caseStudy.gallery} />

            {/* Challenges Faced Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Challenges Faced:</h3>
              <p>The {caseStudy.title} project presented unique challenges in integrating scalable AI solutions, optimizing data pipelines, and aligning tech capabilities with business goals.</p>

              {/* List of Challenges */}
              <ul>
                {caseStudy.challenges.map((challenge, index) => {
                  return <li key={index}><div className='icon'><FaCheck /></div>{challenge}</li>
                })}
              </ul>

            </div>

            {/* Solutions Provided Section */}
            <div className='sub-section'>

              {/* Solutions Provided Intro */}
              <h3 className='sub-heading'>Solutions Provided:</h3>
              <p>For the {caseStudy.title} project, we delivered tailored AI-driven solutions, from model development to seamless integration, ensuring efficient workflows and measurable outcomes.</p>

              {/* List of Solutions */}
              <ul>
                {caseStudy.solutions.map((solution, index) => {
                  return <li key={index}><div className='icon'><FaCaretRight /></div>{solution}</li>
                })}
              </ul>

            </div>

            {/* Results & Impact Section */}
            <div className='sub-section'>

              {/* Results & Impact Intro */}
              <h3 className='sub-heading'>Results & Impact:</h3>
              <p>The {caseStudy.title} project delivered measurable improvements in performance, streamlined operations, and enhanced decision-making through AI-powered insights.</p>

              {/* List of Results */}
              <ul>
                {caseStudy.results.map((result, index) => {
                  return <li key={index}><div className='icon'><FaCircleNotch /></div>{result}</li>
                })}
              </ul>

            </div>

          </div> 
        
        </div> 

        {/* Sidebar with Case Study details */}
        <PageSidebar
          heading={'Case'}
          details={caseStudy.details}
        />

      </section>

    </> 
  );
}

export default CaseSingle;